import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ConnectionDetails from './ConnectionDetails';
import ConnectionDetailsTabState from './ConnectionDetailsTabState';

export default class ConnectionDetailsTabView extends BufferTabView<ConnectionDetailsTabState> {
  override render(): this {
    const props = {
      connectionId: this.model.get('connectionId'),
    };
    renderToDOM(<ConnectionDetails {...props} />, this.el);
    return this;
  }

  override remove(): Backbone.View<ConnectionDetailsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ConnectionDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
